<template>
  <div class="centered-div">
    <h1>Please Wait, You’re Being Redirected...</h1>
    <div class="loader"></div>
  </div>
</template>

<script>
import UrlLoaderService from '@/services/urlLoader';

export default {
  name: 'CallbackPage',
  computed: {
    code() {
      return this.$route.query.code;
    }
  },
  async created() {
    let userData = null;
    if (this.code) {
      try {
        const response = await UrlLoaderService.get('/auth/callback', { code: this.code });
        userData = response.data.userInfo;
        if (userData) {
          localStorage.setItem('10-4-AvatarURL', 'https://cdn.discordapp.com/avatars/' + userData.id + "/" + userData.avatar);
          localStorage.setItem('10-4-Username', userData.global_name);
          const token = userData.token;
          if (token) {
            localStorage.setItem('10-4-Token', token);
            this.login();
            this.$router.push('/dashboard');
          }
        }
      } catch (error) {
        // TODO: Handle Error.
        this.$router.push('/');
      }
    } else {
      this.$router.push('/');
    }
  },
  methods: {
    login() {
      this.$store.dispatch('login');
    }
  }
}
</script>

<style scoped>
.centered-div {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loader {
  --loader-color-1: var(--color-200);
  --loader-color-2: var(--color-600);
  width: 15px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: l5 1s infinite linear alternate;
}

@keyframes l5 {
  0% {
    box-shadow: 20px 0 var(--loader-color-1), -20px 0 var(--loader-color-2);
    background: var(--loader-color-1);
  }

  33% {
    box-shadow: 20px 0 var(--loader-color-1), -20px 0 var(--loader-color-2);
    background: var(--loader-color-2);
  }

  66% {
    box-shadow: 20px 0 var(--loader-color-2), -20px 0 var(--loader-color-1);
    background: var(--loader-color-2);
  }

  100% {
    box-shadow: 20px 0 var(--loader-color-2), -20px 0 var(--loader-color-1);
    background: var(--loader-color-1);
  }
}
</style>
